"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberFormatter = void 0;
const react_1 = require("react");
class PhoneNumberFormatter extends react_1.Component {
    render() {
        const value = String(this.props.value);
        var cleaned = ('' + value).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
    }
}
exports.PhoneNumberFormatter = PhoneNumberFormatter;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/pharmacy/components/phone-number-formatter.tsx
// module id = 3987
// module chunks = 0